import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { BusinessCategoryDeleteCard } from './components/CategoryDeleteCard';
import { BusinessCategoryDetailsCard } from './components/CategoryDetailsCard';

export function BusinessCategoryDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const businessCategoryQueryResults = useQuery({
        queryKey: ['businessCategory', id],
        queryFn: () => Api.BusinessSpecific.Category.getCategory(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={businessCategoryQueryResults}>
                {data => (
                    <Stack gap={2} sx={{ paddingBottom: 4 }}>
                        <BusinessCategoryDetailsCard businessCategory={data} />

                        <Can I="delete" a="BusinessCategory">
                            <BusinessCategoryDeleteCard
                                businessCategory={data}
                            />
                        </Can>
                    </Stack>
                )}
            </QueryRenderer>
        </RootContainer>
    );
}
